import {combineReducers} from 'redux';
import {
  SET_FIRST_NAME,
  SET_LAST_NAME,
  SET_EMAIL_ADDRESS,
  SET_MOBILE_PHONE,
  SET_DATE_OF_BIRTH,
  SET_GENDER,
  SET_MARITAL_STATUS,
  SET_USER_NAME,
  SET_PASSWORD,
  SET_FIRST_NAME_ERRORS,
  SET_LAST_NAME_ERRORS,
  SET_EMAIL_ADDRESS_ERRORS,
  SET_MOBILE_PHONE_ERRORS,
  SET_DATE_OF_BIRTH_ERRORS,
  SET_GENDER_ERRORS,
  SET_MARITAL_STATUS_ERRORS,
  SET_USER_NAME_ERRORS,
  SET_PASSWORD_ERRORS
} from '../actionTypes/me';


export default combineReducers({
  First_Name: combineReducers({
    value(state = '', action) {
      switch (action.type) {
        case SET_FIRST_NAME:
          return action.value;
        default:
          return state;
      }
    },
    errors(state = ["This field is required."], action) {
      switch (action.type) {
        case SET_FIRST_NAME_ERRORS:
          return action.errors;
        default:
          return state;
      }
    }
  }),
  Last_Name: combineReducers({
    value(state = '', action) {
      switch (action.type) {
        case SET_LAST_NAME:
          return action.value;
        default:
          return state;
      }
    },
    errors(state = ["This field is required."], action) {
      switch (action.type) {
        case SET_LAST_NAME_ERRORS:
          return action.errors;
        default:
          return state;
      }
    }
  }),
  Email_Address: combineReducers({
    value(state = '', action) {
      switch (action.type) {
        case SET_EMAIL_ADDRESS:
          return action.value;
        default:
          return state;
      }
    },
    errors(state = ["This field is required."], action) {
      switch (action.type) {
        case SET_EMAIL_ADDRESS_ERRORS:
          return action.errors;
        default:
          return state;
      }
    }
  }),
  Mobile_Phone: combineReducers({
    value(state = '', action) {
      switch (action.type) {
        case SET_MOBILE_PHONE:
          return action.value;
        default:
          return state;
      }
    },
    errors(state = ["This field is required."], action) {
      switch (action.type) {
        case SET_MOBILE_PHONE_ERRORS:
          return action.errors;
        default:
          return state;
      }
    }
  }),
  Date_of_Birth: combineReducers({
    value(state = null, action) {
      switch (action.type) {
        case SET_DATE_OF_BIRTH:
          return action.value;
        default:
          return state;
      }
    },
    errors(state = [], action) {
      switch (action.type) {
        case SET_DATE_OF_BIRTH_ERRORS:
          return action.errors;
        default:
          return state;
      }
    }
  }),
  Gender_ID: combineReducers({
    value(state = null, action) {
      switch (action.type) {
        case SET_GENDER:
          return action.value;
        default:
          return state;
      }
    },
    errors(state = [], action) {
      switch (action.type) {
        case SET_GENDER_ERRORS:
          return action.errors;
        default:
          return state;
      }
    }
  }),
  Marital_Status_ID: combineReducers({
    value(state = null, action) {
      switch (action.type) {
        case SET_MARITAL_STATUS:
          return action.value;
        default:
          return state;
      }
    },
    errors(state = [], action) {
      switch (action.type) {
        case SET_MARITAL_STATUS_ERRORS:
          return action.errors;
        default:
          return state;
      }
    }
  }),
  User_Name: combineReducers({
    value(state = null, action) {
      switch (action.type) {
        case SET_USER_NAME:
          return action.value;
        default:
          return state;
      }
    },
    errors(state = ["This field is required."], action) {
      switch (action.type) {
        case SET_USER_NAME_ERRORS:
          return action.errors;
        default:
          return state;
      }
    }
  }),
  Password: combineReducers({
    value(state = null, action) {
      switch (action.type) {
        case SET_PASSWORD:
          return action.value;
        default:
          return state;
      }
    },
    errors(state = ["This field is required."], action) {
      switch (action.type) {
        case SET_PASSWORD_ERRORS:
          return action.errors;
        default:
          return state;
      }
    }
  })
});


// WEBPACK FOOTER //
// ./src/reducers/me.js